import { render, staticRenderFns } from "./selectDep.vue?vue&type=template&id=28ef0972"
import script from "./selectDep.vue?vue&type=script&lang=js"
export * from "./selectDep.vue?vue&type=script&lang=js"
import style0 from "./selectDep.vue?vue&type=style&index=0&id=28ef0972&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports